import MainTheme from "assets/theme/MainTheme";

export const SUBSCRIPTION_STATUSES = {
    ACTIVE: "active",
    INACTIVE: "inactive",
    TRIAL: "trial",
};

export const SUBSCRIPTION_STATUS_OPTIONS = [
    { label: "Active", value: SUBSCRIPTION_STATUSES.ACTIVE },
    { label: "Inactive", value: SUBSCRIPTION_STATUSES.INACTIVE },
    { label: "Trial", value: SUBSCRIPTION_STATUSES.TRIAL },
];

// Listing API returns subscriptionStatus ("trial"); company view uses
// stripeSubscription.status ("trialing") on subscription row objects.
export const getSubscriptionStatusFromRow = (subscription) => {
    if (subscription?.stripeSubscription?.status === "trialing") {
        return SUBSCRIPTION_STATUSES.TRIAL;
    }

    if (subscription?.isCurrent) {
        return SUBSCRIPTION_STATUSES.ACTIVE;
    }

    return SUBSCRIPTION_STATUSES.INACTIVE;
};

export const getSubscriptionStatusBackgroundColor = (status) => {
    switch (status) {
        case SUBSCRIPTION_STATUSES.ACTIVE:
            return "#c8e6c9";
        case SUBSCRIPTION_STATUSES.INACTIVE:
            return MainTheme.palette.gray.soft;
        case SUBSCRIPTION_STATUSES.TRIAL:
            return "#fff9c4";
        default:
            return "default";
    }
};

export const getSubscriptionStatusLabel = (status) =>
    status ? status.toUpperCase() : "";

export const getSubscriptionDurationLabel = (subscription, status) => {
    const remainingDays = subscription?.remainingDays;

    if (status === SUBSCRIPTION_STATUSES.TRIAL) {
        if (remainingDays) {
            return remainingDays === 1 ? "1 day" : `${remainingDays} days`;
        }

        return "Trial";
    }

    if (!remainingDays) {
        return "Expired";
    }

    return remainingDays === 1 ? "1 day" : `${remainingDays} days`;
};

export const isActiveOrTrialSubscription = (subscription) => {
    const status = getSubscriptionStatusFromRow(subscription);
    return (
        status === SUBSCRIPTION_STATUSES.ACTIVE ||
        status === SUBSCRIPTION_STATUSES.TRIAL
    );
};
